import { render, staticRenderFns } from "./ModalRegraCashback.vue?vue&type=template&id=5301384e&scoped=true"
import script from "./ModalRegraCashback.vue?vue&type=script&lang=js"
export * from "./ModalRegraCashback.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=5301384e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301384e",
  null
  
)

export default component.exports